import React, {useMemo, useState} from "react";
import {
    APPLICATION_MODE_NEW,
    LICENCE_STATUS_ACTIVE,
    APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
    CanadaProvinceList,
    DOCUMENT_CONTENT_TYPE_PDF
} from "../../../../app/constants";
import { convertFileDataForUrl } from "../../../../app/documentUploadUtils";
import {
    combineAddress,
    humanReadableDate,
    licenceSubTypeString
} from "../../../../app/utils";
import DocumentViewer from "../../../../components/DocumentViewer/DocumentViewer";
import {
    LineSeperator,
    NavigationLinkButton
} from "../../../../components/RegularComponents";
import { fetchBusinessLicnecePDF } from "../../../../redux/slice/bltDecisionSlice";
import {InformationDetailPanelSection} from '../InformationDetailPanelSection';
import { Button } from "../../../../components/RegularComponents";
import { setCurrentAgentMortgageProperty } from "../../../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../../../redux/slice/businessLicenceApplicationSlice";
import userAuthSelect  from '../../../../redux/selector/userAuthSelector';
import {
    useDispatch,
    useSelector
} from "react-redux";

export const IndividualInformationTab = (props) => {
    const {
        licenceApplication,
        appData,
        applicationType,
        isArchiveApplication
    } = props;

    const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const [sectionToEdit,setSectionToEdit] = useState([]);
    const {userAuth} = useSelector(userAuthSelect)
    const dispatch = useDispatch()

    const userEmail = licenceApplication?.userEmail;

    const provinceOptionElements = useMemo(() => {
        return Object.keys(CanadaProvinceList).map((key) => {
          const element = CanadaProvinceList[key];
          return (
            <option key={key} value={element}>
              {element}
            </option>
          );
        });
      }, []);
      
    const handleClick = (section) => {
        let data

        if(section in appData.personData) {
            data = appData.personData[section]
        }

        // switch(section) {
        //     case 'firstName':
        //         data = appData.personData.firstName
        //         break
        //     case 'lastName':
        //         data = appData.personData.lastName
        //         break
        //     case 'addressData':
        //         data = appData.personData.addressData
        //         break
        //     case 'phoneNumber':
        //         data = appData.personData.phoneNumber
        //         break
        //     case 'email':
        //         data = appData.personData.email
        //         break
        //     default:
        //         data = ""
        //         break
        // }
        
        if(typeof data !== "undefined")  {
            let newSectionEditObj = {...sectionToEdit}
            newSectionEditObj[section] = data
            // Object.defineProperty(newSectionEditObj,section,{value: data, enumerable: true, writable: true})
            setSectionToEdit(newSectionEditObj)
        }
    }

    const handleSave = (section) => {
        if(section === "firstName") {
            // appData.mainBusinessContact
            dispatch(setCurrentAgentMortgageProperty({
                key: "personData",
                value : {...appData.personData, firstName: sectionToEdit[section]},
                changeBy : userAuth.userData.email,
                changeValidated : true
            }))
        } else if(section === "lastName") {
            dispatch(setCurrentAgentMortgageProperty({
                key: "personData",
                value : {...appData.personData, lastName: sectionToEdit[section]},
                changeBy : userAuth.userData.email,
                changeValidated : true
            }))
        }  else if(section === "addressData") {
            dispatch(setCurrentAgentMortgageProperty({
                key: "personData",
                value : {...appData.personData, addressData: sectionToEdit[section]},
                changeBy : userAuth.userData.email,
                changeValidated : true
            }))
        } else if(section === "phoneNumber") {
            dispatch(setCurrentAgentMortgageProperty({
                key: "personData",
                value : {...appData.personData, phoneNumber: sectionToEdit[section]},
                changeBy : userAuth.userData.email,
                changeValidated : true
            }))
        } else if(section === "email") {
            dispatch(setCurrentAgentMortgageProperty({
                key: "personData",
                value : {...appData.personData, email: sectionToEdit[section]},
                changeBy : userAuth.userData.email,
                changeValidated : true
            }))
        }

        dispatch(saveBusinessLicenceApplicationData(applicationType, APPLICATION_MODE_NEW))
            .then(data => {
                // save successful
                let newSectionEditObj = {...sectionToEdit}
                delete newSectionEditObj[section]
                setSectionToEdit(newSectionEditObj)
            })
            .catch(err => {
                // save error
            })
    }

    // const homeAddress = useMemo(() => {
    //     if(!appData) { return null }
    //     return combineAddress(appData?.personData?.addressData)
    // }, [appData])

    const lastUpdated = useMemo(() => {
        if(!licenceApplication) { return null }
        return humanReadableDate(licenceApplication.modifiedDateTime)
    }, [licenceApplication])
    
    const getApplicationLicencePDF = async (applicationId) => {
        const pdf = await fetchBusinessLicnecePDF(applicationId);
        let fileDataUrl = convertFileDataForUrl(
          pdf.file,
          DOCUMENT_CONTENT_TYPE_PDF
        );
        setDocumentViewerDocument(fileDataUrl);
        setSelectedFile(pdf);
        setOpenDocumentViewer(true);
    };

    const inputEditForm = (sectionKey) => {
        const value = sectionToEdit[sectionKey]
        
        const onChange = (changedValue) => {
            setSectionToEdit(Object.defineProperty({...sectionToEdit},
                sectionKey,
                {value : changedValue, writable: true, enumerable: true})
            )
        }

        return (
            <fieldset className={"ns-fieldset"} id="edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="edit-form"
                        name="edit-form"
                        value={value}
                        onChange={(e) => {
                            onChange(e.target.value)
                        }}
                    />
                </div>
            </fieldset>
        )
    }

    const editAddressForm = (sectionKey, businessAddress) => {
        const onChange = (property, value) => {
            
            let updatedAddress = {...sectionToEdit[sectionKey]}
            Object.defineProperty(updatedAddress, property, {value : value, writable: true, enumerable: true})

            let updatedSectionToEdit = {...sectionToEdit}
            Object.defineProperty(updatedSectionToEdit, sectionKey, {
                value : updatedAddress, 
                writable: true, 
                enumerable: true
            })
            setSectionToEdit(updatedSectionToEdit)
        }

        return (
            <fieldset className={"ns-fieldset"} id="business-address-edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        className="ns-label"
                        autoComplete="street-address"
                        htmlFor="businessAddressStreetEdit">
                            Street Address
                    </label>
                    <textarea
                        className="fw-25 ns-input"
                        type="text"
                        id="businessAddressStreetEdit"
                        rows={4} 
                        cols={60}
                        name="address"
                        onChange={e => onChange("address1", e.target.value)}>
                            {businessAddress["address1"]}
                    </textarea>
                </div>
                <div className="ns-fieldset row bottomMarginNormal">
                    <label for="businessAddressCityEdit">City</label>
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="businessAddressCityEdit"
                        name="city"
                        value={businessAddress["cityName"]}
                        onChange={e => onChange("cityName", e.target.value)} />
                </div>
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        id={"mra-province-select-label"}
                        className="ns-label"
                        htmlFor={"mra-province-select-input"}
                    >
                        Province
                    </label>
                    <div className="select fw-25 inlineDisplay">
                        <select
                        style={{ width: "25em" }}
                        id={"mra-province-select-input"}
                        name={"mra-province-select-input"}
                        value={businessAddress["stateName"] ?? ""}
                        onChange={e => onChange("stateName", e.target.value)}
                        >
                        {provinceOptionElements}
                        </select>
                    </div>
                </div>
                <div className="ns-fieldset row">
                    <label htmlFor="businessAddressPINEdit">Postal Code</label>
                    <input
                        type="text"
                        className="fw-25"
                        id="businessAddressPINEdit"
                        name="pin"
                        value={businessAddress["postalCode"]}
                        onChange={e => onChange("postalCode", e.target.value)} 
                    />
                </div>
            </fieldset>
        )
    }

    const canModifyName = () => {
        return (applicationType !== APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE)
    }

    let considerRenewalName = true;
    if(licenceApplication.licenceStatus === LICENCE_STATUS_ACTIVE) {
        considerRenewalName = false;
    }

    return (
        <div style={{marginTop: "1em"}}>
            <InformationDetailPanelSection 
                header={"Licence Type"} 
                value={licenceSubTypeString(licenceApplication.licencingSubType, considerRenewalName)} />
            <LineSeperator />

            <InformationDetailPanelSection 
                header={"Licence number"}
                value={licenceApplication.licenceNumber ?? ""} />
            <LineSeperator />

            <InformationDetailPanelSection header={"Licence pdf"} value={
                <NavigationLinkButton 
                    style={{marginLeft: "-6px"}}
                    text={licenceApplication.contactName} 
                    onClick={() => {
                        // send PDF request
                        let id = licenceApplication.id
                        if(isArchiveApplication) {
                            id = licenceApplication.originalApplicationId
                        }
                        getApplicationLicencePDF(id)
                    }}
                />
            }/>
            <LineSeperator />

            <InformationDetailPanelSection 
                header={"First name"} 
                value={
                sectionToEdit["firstName"] ? 
                    inputEditForm("firstName") :
                        appData.personData?.firstName ?? ""
                }>
                {canModifyName() && (sectionToEdit["firstName"] ?
                    <Button 
                        buttonType="regular_success" 
                        text={"Save"} 
                        onClick={() => handleSave("firstName")} 
                    /> : 
                    <Button 
                        buttonType="regular_primary" 
                        disabled={isArchiveApplication}
                        text={"Edit"} 
                        onClick={() => handleClick("firstName")} 
                    />)
                }
            </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header={"Last name"} 
                value={
                    sectionToEdit["lastName"] ? 
                        inputEditForm("lastName") :
                            appData.personData?.lastName ?? ""
                    }>
                {canModifyName() && (sectionToEdit["lastName"] ?
                    <Button 
                        buttonType="regular_success" 
                        text={"Save"} 
                        onClick={() => handleSave("lastName")} 
                    /> : 
                    <Button 
                        buttonType="regular_primary" 
                        disabled={isArchiveApplication}
                        text={"Edit"} 
                        onClick={() => handleClick("lastName")} 
                    />)
                }
            </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header={"Home address"} 
                value={sectionToEdit["addressData"] ? 
                        editAddressForm("addressData",sectionToEdit["addressData"]) : 
                        combineAddress(appData.personData?.addressData)}>
                {sectionToEdit["addressData"] ?
                    <Button 
                        buttonType="regular_success" 
                        text={"Save"} 
                        onClick={() => handleSave("addressData")} 
                    /> : 
                    <Button 
                        buttonType="regular_primary"
                        disabled={isArchiveApplication} 
                        text={"Edit"} 
                        onClick={() => handleClick("addressData")} 
                    />
                }
            </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header={"Phone"} 
                value={("phoneNumber" in sectionToEdit) ? 
                        inputEditForm("phoneNumber") :
                            appData.personData?.phoneNumber ?? ""}>
                {("phoneNumber" in sectionToEdit) ?
                    <Button 
                        buttonType="regular_success" 
                        text={"Save"} 
                        onClick={() => handleSave("phoneNumber")} 
                    /> : 
                    <Button 
                        buttonType="regular_primary" 
                        disabled={isArchiveApplication}
                        text={"Edit"} 
                        onClick={() => handleClick("phoneNumber")} 
                    />
                }
            </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header={"Email"} 
                value={("email" in sectionToEdit) ? 
                        inputEditForm("email") :
                            appData.personData?.email ?? ""}>
                {("email" in sectionToEdit) ?
                    <Button 
                        buttonType="regular_success" 
                        text={"Save"} 
                        onClick={() => handleSave("email")} 
                    /> : 
                    <Button 
                        buttonType="regular_primary"
                        disabled={isArchiveApplication} 
                        text={"Edit"} 
                        onClick={() => handleClick("email")} 
                    />
                }
            </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header={"Login e-mail address"} 
                value={userEmail}/>
            <LineSeperator />

            <InformationDetailPanelSection 
                header={"Last updated"} 
                value={lastUpdated} />
            <LineSeperator />

            <DocumentViewer
                fileData={documentViewerDocument}
                isOpen={openDocumentViewer}
                fileName={selectedFile?.filename}
                handleClose={() => setOpenDocumentViewer(false)}
            />
        </div>
    )
}

// const DetailSection = ({ header, value, children }) => {
//     return (
//         <div className="row">

//             <div className="collector-licence-col col-md-3" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
//                 <span>{header}</span>
//             </div>

//             <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
//                 {value}
//             </div>
//             <div className="collector-licence-action-col col-md-3" style={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}>
//                 {children}
//             </div>
//         </div>
//     )
// }